namespace $ {

	$mol_style_attach( '$shm_hitalama_map_widget_float_text_md_links', `
		[shm_hitalama_map_widget_float_text_md] [mol_text_link] {
			pointer-events: auto;
		}
	` )

}

namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_text_md, {
		background: {
			color: $mol_theme.card,
		},

		Md: {
			pointerEvents: 'none',

			Link: {
				pointerEvents: 'auto',
			},

			Link_http: {
				pointerEvents: 'auto',
			},
		},
		'[shm_hitalama_map_widget_float_locked]': {
			true: {
				Md: { pointerEvents: 'auto' },
			},
		},

		Link_favicon_help_text: {
			maxWidth: '20rem',
			padding: $mol_gap.text,
		},

	} )

}
